import { render } from "./FormShowTrip.vue?vue&type=template&id=68d8eb40&scoped=true"
import script from "./FormShowTrip.vue?vue&type=script&lang=js"
export * from "./FormShowTrip.vue?vue&type=script&lang=js"

import "./FormShowTrip.vue?vue&type=style&index=0&id=68d8eb40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d8eb40"]])

export default __exports__